export const PROFILES_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data'
}
